module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (178).1280494d.jpg";